import { Navigate } from "react-router-dom";
import { useContext } from "react";

import { AuthContext } from "../contexts/AuthContext";

const PublicRoute = ({ element }: any) => {
  const { isAuthenticated } = useContext(AuthContext);

  if (isAuthenticated) {
    // Check if the user is trying to access the login, forgot password, or reset password page
    const allowedPages = ["Login", "ForgotPassword", "ResetPassword"];

    if (element && element.type && allowedPages.includes(element.type.name)) {
      // Redirect the user to a different page, e.g., the home page
      return <Navigate to='/' replace />;
    }
  }

  return element;
};

export default PublicRoute;
